import type { Tutorial } from '.';
import type { TutorialStep } from './tutorial.ruleset';

import { action } from '@play-co/replicant';
import { defineActions } from '../../utils';

export const tutorialActions = (
  Tutorial: Tutorial,
  { Inventory }: Tutorial['$DEPENDENCIES'],
) =>
  defineActions<Tutorial>()({
    completeTutorialStep: action((state, step: TutorialStep, api) => {
      if (Tutorial.getters(state).isTutorialStepComplete(step)) {
        throw new Error(`Tutorial step already complete: ${step}`);
      }

      const { getCurrencies } = Inventory.getters(state);
      const now = api.date.now();
      const oldCurrencies = getCurrencies(now);
      const reward = Tutorial.getters(state).getTutorialReward(step);
      Inventory.modifiers(state).addPoints(reward);
      Tutorial.modifiers(state).setTutorialStepComplete(step);

      // Send CurrencyGrant event
      api.sendAnalyticsEvents([
        Inventory.ruleset.getCurrencyGrantEvent(
          {
            feature: 'tutorial_reward',
            $subFeature: step,
          },
          {
            old: oldCurrencies,
            new: getCurrencies(now),
          },
        ),
      ]);
    }),
  });
